<script>

// 定义全局变量
const bei_ing = 'img_29.png';
const imgSrc = require('../../assets/img/img_11.png');
const imgSrcBg = require('../../assets/img/loginbg.png');

export default {
  bei_ing,   //背景图片
  imgSrc,
  imgSrcBg
}
</script>